import Vue from 'vue'
import VueRouter from 'vue-router'

const Login = () => import('../views/Login.vue')
const Home = () => import('../views/Home.vue')
const Welcome = () => import('../views/Welcome.vue')
const User = () => import('../views/user/userManage.vue')
const Xilie = () => import('../views/xilie/userManage.vue')
const Caizhi = () => import('../views/caizhi/userManage.vue')
const Gongyi = () => import('../views/gongyi/userManage.vue')
const Guangzegu = () => import('../views/guangzedu/userManage.vue')
const Yanse = () => import('../views/yanse/userManage.vue')
const Guige = () => import('../views/guige/userManage.vue')
const Product = () => import('../views/product/userManage.vue')
const Bannar = () => import('../views/bannar/userManage.vue')
const Tuijian = () => import('../views/tuijian/userManage.vue')
const Company = () => import('../views/company/userManage.vue')
const Contact = () => import('../views/contact/userManage.vue')

const Company2 = () => import('../views/js/company/indexManage.vue')
const Place = () => import('../views/js/place/indexManage.vue')
const PlaceData = () => import('../views/js/placeData/indexManage.vue')
const MData = () => import('../views/js/mData/indexManage.vue')
const YData = () => import('../views/js/yData/indexManage.vue')

const Index = () => import('../views/index/Index.vue')

const newerror = () => import('../views/error/newerror.vue')
const workingerror = () => import('../views/error/workingerror.vue')
const enderror = () => import('../views/error/enderror.vue')
const Regime =() => import('@/views/regime/regimeEidt.vue')

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '/home', component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },
      { path: '/user', component: User },
      { path: '/xilie', component: Xilie },
      { path: '/caizhi', component: Caizhi },
      { path: '/gongyi', component: Gongyi },
      { path: '/guangzedu', component: Guangzegu },
      { path: '/yanse', component: Yanse },
      { path: '/guige', component: Guige },
      { path: '/product', component: Product },
      { path: '/bannar', component: Bannar },
      { path: '/tuijian', component: Tuijian },
      { path: '/company', component: Company },
      { path: '/contact', component: Contact },

      { path: '/place', component: Place },
      { path: '/placeData', component: PlaceData },
      { path: '/m_data', component: MData },
      { path: '/y_data', component: YData },
      
      { path: '/newerror', component: newerror },
      { path: '/workingerror', component: workingerror },
      { path: '/enderror', component: enderror },
      { path: '/regime', component: Regime}
    ]
  },
  { path: '/index', component: Index }
]

const router = new VueRouter({
  routes
})


export default router
